import { render, staticRenderFns } from "./Accepted.vue?vue&type=template&id=f60cc4a2&scoped=true&"
import script from "./Accepted.vue?vue&type=script&lang=js&"
export * from "./Accepted.vue?vue&type=script&lang=js&"
import style0 from "./Accepted.vue?vue&type=style&index=0&id=f60cc4a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f60cc4a2",
  null
  
)

export default component.exports
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QImg});
